<template>

    <v-container class="pa-0">
        <v-layout row>
            <v-flex xs12>

                <v-list>

                    <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>Dunkles Design</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-avatar>
                            <v-switch color="green" v-model="darkMode" ></v-switch>
                        </v-list-tile-avatar>
                    </v-list-tile>

                </v-list>

            </v-flex>
        </v-layout>

        <template v-if="installIsPossible === true">
            <v-divider class="mb-4"></v-divider>

            <v-layout row>
                <v-flex xs12>
                    <v-btn
                          class="success"
                      :dark="darkMode===true"
                      @click="doInstall"
                    >
                        <v-icon class="icon-download" left></v-icon> App installieren
                    </v-btn>
                </v-flex>
            </v-layout>
        </template>

    </v-container>

</template>

<script>
    export default {
        name: 'einstellungen',
        props: {

        },
        computed: {

            installIsPossible() {
                return ( this.$store.getters.installPrompt !== null && typeof this.$store.getters.installPrompt !== "undefined" );
            },

            darkMode: {
                set: function(val){
                    this.$vuetify.theme.primary = ( val === true ) ? '#6BA5ED' : '#1976d2';

                    this.$store.dispatch("darkMode", val);
                },
                get() {
                    return this.$store.getters.darkMode;
                }
            }
        },
        watch: {

        },
        data: () => ({

        }),
        methods: {

            doInstall() {

                if ( this.installIsPossible ) {
                    this.$store.getters.installPrompt.prompt();
                    // Wait for the user to respond to the prompt
                    this.$store.getters.installPrompt.userChoice
                        .then((choiceResult) => {
                            if (choiceResult.outcome === 'accepted') {
                                //console.log('User accepted the A2HS prompt');
                                this.$store.dispatch("installPrompt", null);
                            } else {
                                //console.log('User dismissed the A2HS prompt');
                            }
                    });
                }
            }

        }
    }
</script>

<style scoped>

</style>
